import { ChangeEvent, useState } from "react";
import { CellProps } from "react-table";
import Input from "src/components/inputs/Input";
import ImageTextCell from "src/components/tables/cells/ImageTextCell";
import TextCell from "src/components/tables/cells/TextCell";
import { PR_STATUS } from "src/utils/constants";
import { ProcurementRequestProducts } from "./purchase-order-types";

const useCreatePurchaseOrderTableColumns = ({
  handleUnitPriceChange,
  status,
}: {
  handleUnitPriceChange: (e: ChangeEvent<HTMLInputElement>, id: number) => void;
  status: PR_STATUS;
}) => {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: ({ row: { original } }: CellProps<ProcurementRequestProducts>) => (
        <ImageTextCell
          className="justify-center items-center"
          imageSrc={original?.products?.image}
          value={original?.products?.name}
        />
      ),
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Unit Price",
      accessor: "unitPrice",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<ProcurementRequestProducts>) => {
        const [price, setPrice] = useState(original.products.price);
        if (status === PR_STATUS.PENDING) {
          return (
            <Input
              name="unitPrice"
              type="number"
              label={""}
              value={price}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setPrice(e.target.value)
              }
              onBlur={(e: ChangeEvent<HTMLInputElement>) =>
                handleUnitPriceChange(e, original.productId)
              }
              error={price ? "" : "Required"}
              className="[&>div>div]:border-t-0 [&>div>div]:border-x-0"
            />
          );
        } else {
          return <TextCell value={original.offeredPrice} />;
        }
      },
    },
    {
      Header: "Total Price",
      accessor: "totalPrice",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
  ];
};

export default useCreatePurchaseOrderTableColumns;
